import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ApiService } from './api.service';
import { APIResponse } from '../index';

@Injectable()
export class TemporaryUrlService {
  constructor(private http: Http, private apiService: ApiService) {}

  isPathValid(path: any): Promise<APIResponse<any, any>> {
    return this.apiService.postPromise('/password/isvalid', path);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/temporary-url.service.ts